import {Component, EventEmitter, Output} from '@angular/core';
import {selectCanDeleteSegment} from '../../../user/user.reducer';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-segment-delete-button',
  template: `
    <button *ngIf="isAllowed$ | async"
            mat-icon-button
            name="button-segment-info-delete"
            data-cy="button-segment-info-delete"
            (click)="deleteSegment()">
      <mat-icon>delete</mat-icon>
    </button>`
})
export class SegmentDeleteButtonComponent {
  @Output() deleteEmitter = new EventEmitter<number>();
  isAllowed$: Observable<boolean> = this.store.select(selectCanDeleteSegment);

  constructor(private store: Store) {
  }

  deleteSegment() {
    this.deleteEmitter.emit();
  }


}
